/**
 * O caso no portal em abas (E148 — GUS-109, ADR-0102 §2): andamento, documentos e relatórios.
 *
 * Linguagem do cliente: o estado real e uma próxima ação, sem termo técnico e sem métrica. Prazo só
 * o que o cliente informou; a previsão de entrega não existe ainda (GUS-162) e não aparece.
 */
export const ptBRCaso = {
  abas: {
    rotulo: 'Seções do caso',
    andamento: 'Andamento',
    documentos: 'Documentos',
    conversa: 'Conversa',
    relatorios: 'Relatórios',
  },
  cabecalho: {
    kicker: 'Caso',
    breadcrumb: 'Casos',
    // E165.F1.T03 (HTML 6.8): os mesmos nomes da abertura em todas as telas.
    servico: {
      grafotecnica: 'Contrato Não Digital',
      eletronica: 'Contrato Digital',
    },
  },
  estado: {
    preparacao: 'Em preparação',
    exame: 'Em exame',
    conferencia: 'Em conferência interna',
    aguardando_cliente: 'Aguardando documento solicitado',
    entregue: 'Exame entregue',
    cancelado: 'Cancelado',
  },
  estadoTexto: {
    preparacao: 'A equipe está organizando o material recebido.',
    exame: 'A equipe está examinando o material. Avisaremos por aqui quando houver entrega.',
    conferencia: 'A entrega está em conferência interna. Nenhuma ação sua é necessária.',
    aguardando_cliente: 'A equipe pediu um documento para continuar o exame.',
    entregue: 'O exame deste caso foi entregue.',
    cancelado: 'A equipe cancelou este caso.',
  },
  proximaAcao: {
    titulo: 'Próxima ação',
    aguardar_equipe: 'Nenhuma ação sua agora: a equipe segue com o caso.',
    enviar_documento_pedido: 'Envie o documento solicitado ou informe que não o tem.',
    consultar_exame: 'Consulte o exame entregue.',
    baixar_laudo: 'O laudo para o processo está disponível.',
    nenhuma: 'Nenhuma ação: o caso foi cancelado.',
    botao: {
      enviar_documento_pedido: 'Ver o pedido',
      consultar_exame: 'Ver o exame',
      baixar_laudo: 'Ver o laudo',
    },
  },
  // E224.F3 (ADR-0151 §5): o caso que a equipe cancelou, com o motivo, no lugar da próxima ação.
  cancelado: {
    titulo: 'Caso cancelado',
    quando: 'Cancelado pela equipe em {{data}}.',
    motivo: 'Motivo: {{motivo}}',
    semEnvio:
      'Este caso não recebe mais documentos. Para enviar o contrato de novo, abra um caso novo.',
  },
  dados: {
    titulo: 'Dados do caso',
    identificador: 'Identificador',
    // E165.F2.C02 (GUS-221 F02, HTML 6.8): a CCB do caso, a declarada ou a lida na cédula.
    ccb: 'CCB',
    ccbNaoIdentificada: 'Não identificada',
    // E177.F5.C01 (GUS-253 item 4): o número informado segue; o lido no pacote fica à vista.
    divergencia: 'Divergência na abertura',
    divergenciaTexto: 'CCB {numero} informada; o pacote indica {fonte} {lido}',
    servico: 'Serviço',
    contratos: 'Contratos',
    pecas: 'Documentos em exame',
    pasta: 'Pasta',
    processo: 'Processo',
    partes: 'Partes',
    recebidoEm: 'Recebido em',
    naoInformado: 'Não informado',
  },
  atualizacoes: {
    titulo: 'Atualizações',
    vazio: 'Nenhuma atualização ainda.',
    envio_recebido: 'Recebemos o envio com {{n}} arquivo(s).',
    complemento_recebido: 'Recebemos o complemento com {{n}} arquivo(s).',
    exame_entregue: 'O exame foi entregue.',
    laudo_disponivel: 'O laudo {{documento}} está disponível.',
    caso_cancelado: 'A equipe cancelou o caso.',
  },
  material: {
    titulo: 'Material do caso',
    resumo: '{{n}} documento(s) guardado(s) neste caso.',
    verDocumentos: 'Ver documentos',
  },
  prazos: {
    titulo: 'Prazos do caso',
    prazoProcessual: 'Prazo processual informado',
    urgencia: 'Urgência',
    naoInformado: 'Não informado',
    naoSolicitada: 'Não solicitada',
    solicitada: 'Solicitada: {{motivo}}',
    nota: 'Aqui aparece só o que foi informado no pedido do processo.',
  },
  documentos: {
    // E165.F2.C03 (GUS-221 F04, HTML 6.8): a lista primeiro, no card "Documentos do caso".
    titulo: 'Documentos do caso',
    vazio: 'Nenhum documento neste caso ainda.',
    envio: 'Envio de {{data}}',
    complemento: 'Complemento de {{data}}',
    situacao: {
      examinado: 'Recebido',
      nao_examinado: 'Guardado, fora do exame',
      copia_identica: 'Já estava no caso',
      encaminhado: 'Encaminhado a outro caso',
    },
    destino: 'Está no caso {{codigo}}',
    outros: 'Outros documentos do caso',
  },
  // E165.F2.T05 (HTML 6.8, GUS-109, GUS-191): o aviso do estado da entrega, os cards Exame e
  // Relatório de risco na mesma versão, com a faixa de uso interno junto ao card e ao download, e as
  // versões anteriores recolhidas. Antes da liberação, nenhum arquivo do conjunto é oferecido.
  relatorios: {
    entrega: {
      disponivel: 'Entrega disponível · versão {{versao}}',
      incompleta: 'Entrega incompleta',
      em_preparacao: 'Entrega em preparação',
    },
    entregaTexto: {
      disponivel: 'Exame liberado para seu acesso.',
      disponivelComRisco: 'Exame e relatório de risco liberados para seu acesso.',
      incompleta:
        'Não foi possível preparar o relatório de risco. A equipe precisa concluir a entrega.',
      em_preparacao: 'Aguardando conclusão da equipe.',
    },
    disponivelNaVersao: 'Disponível · versão {{versao}}',
    emPreparacao: 'Em preparação',
    exameTitulo: 'Exame',
    exameTexto: 'Para o processo.',
    baixarExame: 'Baixar exame',
    baixarExameDaCcb: 'Baixar exame · {{documento}}',
    riscoTitulo: 'Relatório de risco',
    baixarRisco: 'Baixar relatório de risco',
    visualizarRisco: 'Visualizar relatório de risco',
    erroRisco: 'Não foi possível baixar o relatório de risco. Tente novamente.',
    laudoMeta: '{{documento}} · versão {{versao}} · emitido em {{data}}',
    versoesTitulo: 'Versões anteriores',
    versoesTexto:
      'Consultar as entregas anteriores autorizadas sem misturar seus arquivos com a versão atual.',
    versoesVazio: 'Nenhuma versão anterior deste caso.',
    baixarVersao: 'Baixar a versão {{versao}}',
    codigo: 'Código de verificação',
    erroBaixar: 'Não foi possível baixar o exame. Tente novamente.',
    erroDivergente:
      'O arquivo guardado não confere com o registro da emissão e não foi entregue. A ocorrência ficou registrada.',
    erroEntregaIncompleta:
      'O laudo desta versão é entregue junto com o relatório de risco, que ainda está sendo liberado. Tente de novo em instantes.',
  },
  pecas: {
    semTipo: 'Documento',
  },

  documentoDoLaudo: {
    ccb: 'da CCB {{numero}}',
    contrato: 'do contrato',
  },
  erroAcompanhamento: 'Não foi possível carregar o andamento do caso. Tente novamente.',
} as const;
